import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";
import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import LegacyFilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import IntervalUnit from "@app/enum/IntervalUnit";
import { ActivityFieldName } from "@app/util/fieldModel/ActivityFieldModel";

const mapActivityStatusOptionToFilter: Record<ActivityStatusOption, Partial<LegacyFilterModel>> = {
  [ActivityStatusOption.ALL]: {
    [ActivityFieldName.COMPLETED]: undefined,
    [ActivityFieldName.START_AT]: undefined,
  },
  [ActivityStatusOption.COMPLETED]: {
    [ActivityFieldName.COMPLETED]: { operator: FilterOperator.IS_TRUE, value: undefined },
    [ActivityFieldName.START_AT]: undefined,
  },
  [ActivityStatusOption.INCOMPLETE]: {
    [ActivityFieldName.COMPLETED]: { operator: FilterOperator.IS_FALSE, value: undefined },
    [ActivityFieldName.START_AT]: undefined,
  },
  [ActivityStatusOption.NOT_SCHEDULED]: {
    [ActivityFieldName.COMPLETED]: undefined,
    [ActivityFieldName.START_AT]: { operator: FilterOperator.EMPTY, value: undefined },
  },
  [ActivityStatusOption.OVERDUE]: {
    [ActivityFieldName.COMPLETED]: { operator: FilterOperator.IS_FALSE, value: undefined },
    [ActivityFieldName.START_AT]: {
      operator: FilterOperator.INTERVAL_BEFORE,
      value: { unit: IntervalUnit.DAY, value: 0 },
    },
  },
  [ActivityStatusOption.UPCOMING]: {
    [ActivityFieldName.COMPLETED]: { operator: FilterOperator.IS_FALSE, value: undefined },
    [ActivityFieldName.START_AT]: {
      operator: FilterOperator.INTERVAL_AFTER,
      value: { unit: IntervalUnit.DAY, value: 0 },
    },
  },
};

export default mapActivityStatusOptionToFilter;
